/**
 * Every game of the thirty by its id (show-core `thirty.ts`). AIM THE DISH took PASS IT ON's place
 * on 6 Oct 2026; the classic set keeps its RELAY board (games/Relay.tsx).
 */
import type { ThirtyId } from '@continuum/show-core';
import type { ThirtyModule } from './kit.js';
import { game as nav_gaps } from './nav/gaps.js';
import { game as nav_stars } from './nav/stars.js';
import { game as nav_rocks } from './nav/rocks.js';
import { game as nav_heading } from './nav/heading.js';
import { game as nav_dock } from './nav/dock.js';
import { game as eng_coils } from './eng/coils.js';
import { game as eng_pressure } from './eng/pressure.js';
import { game as eng_wires } from './eng/wires.js';
import { game as eng_pipes } from './eng/pipes.js';
import { game as eng_fuses } from './eng/fuses.js';
import { game as bio_vine } from './bio/vine.js';
import { game as bio_bees } from './bio/bees.js';
import { game as bio_seeds } from './bio/seeds.js';
import { game as bio_mushrooms } from './bio/mushrooms.js';
import { game as bio_water } from './bio/water.js';
import { game as sig_echo } from './sig/echo.js';
import { game as sig_tune } from './sig/tune.js';
import { game as sig_wave } from './sig/wave.js';
import { game as sig_code } from './sig/code.js';
import { game as sig_dish } from './sig/dish.js';
import { game as arc_pairs } from './arc/pairs.js';
import { game as arc_mend } from './arc/mend.js';
import { game as arc_shadow } from './arc/shadow.js';
import { game as arc_changed } from './arc/changed.js';
import { game as arc_order } from './arc/order.js';
import { game as qtm_pour } from './qtm/pour.js';
import { game as qtm_count } from './qtm/count.js';
import { game as qtm_scales } from './qtm/scales.js';
import { game as qtm_pack } from './qtm/pack.js';
import { game as qtm_shares } from './qtm/shares.js';

export const THIRTY_BOARDS: Record<ThirtyId, ThirtyModule> = {
  'nav.gaps': nav_gaps,
  'nav.stars': nav_stars,
  'nav.rocks': nav_rocks,
  'nav.heading': nav_heading,
  'nav.dock': nav_dock,
  'eng.coils': eng_coils,
  'eng.pressure': eng_pressure,
  'eng.wires': eng_wires,
  'eng.pipes': eng_pipes,
  'eng.fuses': eng_fuses,
  'bio.vine': bio_vine,
  'bio.bees': bio_bees,
  'bio.seeds': bio_seeds,
  'bio.mushrooms': bio_mushrooms,
  'bio.water': bio_water,
  'sig.echo': sig_echo,
  'sig.tune': sig_tune,
  'sig.wave': sig_wave,
  'sig.code': sig_code,
  'sig.dish': sig_dish,
  'arc.pairs': arc_pairs,
  'arc.mend': arc_mend,
  'arc.shadow': arc_shadow,
  'arc.changed': arc_changed,
  'arc.order': arc_order,
  'qtm.pour': qtm_pour,
  'qtm.count': qtm_count,
  'qtm.scales': qtm_scales,
  'qtm.pack': qtm_pack,
  'qtm.shares': qtm_shares,
};

/** A game's module; undefined only for an id this build does not know (a frame from a newer phone). */
export function thirtyBoard(id: ThirtyId): ThirtyModule | undefined {
  return THIRTY_BOARDS[id];
}
